import React from 'react'
import type { KambiHistoryCoupon } from '@mobi/api-types/kambi'
import { SummaryLine } from '@mobi/betslip/Components/Common/SummaryLine'
import { getLegsProgressOutcomes } from '@core/Areas/KambiSports/Player/helpers/getLegsProgressOutcomes'
import { LegsProgressStatus } from '@core/Areas/KambiSports/Player/Components/Coupon/Components/Common/LegsProgressStatus'

export const LegsStatusLine: React.FC<{
  historyCoupon: KambiHistoryCoupon
  betType: string
}> = ({ historyCoupon, betType }) => {
  const { events, betOffers, outcomes } = historyCoupon

  const isMulti = betType === 'multi'

  const eventsForBet = isMulti ? events : [events[0]]
  const outcomesForBet = isMulti ? getLegsProgressOutcomes(historyCoupon) : outcomes

  return (
    <SummaryLine
      left='Legs'
      right={
        <LegsProgressStatus outcomes={outcomesForBet} betOffers={betOffers} events={eventsForBet} />
      }
    />
  )
}
